import React, { useState, useEffect } from "react";
import Header from "./Header";
import DownloadArrow from "../img/DownloadArrow.svg";
import api from "../../api/axiosInstance";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import html2canvas from "html2canvas";
import InvoiceTemplate from "./InvoiceTemplate";

const ViewInvoice = () => {
  const [pastInvoices, setPastInvoices] = useState([]); // State to store past invoices
  const [upcomingSessions, setUpcomingSessions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [showPreview, setShowPreview] = useState(false);

  const fetchPastInvoices = async () => {
    const accessToken = localStorage.getItem("accessToken");

    if (!accessToken) {
      alert("Please log in first.");
      return;
    }

    try {
      const response = await api.get("/display/api/v1/list-past-invoices", {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (response.data.status === "success") {
        setPastInvoices(response.data.data.results); // Store the invoices data in state
      } else {
        console.error(
          "Failed to fetch past invoices:",
          response.data.response_code
        );
      }
    } catch (error) {
      console.error("Error fetching past invoices:", error);
    } finally {
      setLoading(false);
    }
  };

  // Fetch past invoices on component mount
  const fetchUpcomingSessions = async () => {
    const accessToken = localStorage.getItem("accessToken");

    if (!accessToken) {
      alert("Please log in first.");
      return;
    }

    try {
      console.log("Making API call to fetch upcoming sessions...");
      const response = await api.get("/display/api/v1/list-remider-invoices", {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      console.log("API response:", response); // Log the full response

      if (response.data.status === "success") {
        setUpcomingSessions(response.data.data.results); // Store the sessions in state
      } else {
        console.error(
          "Failed to fetch upcoming sessions:",
          response.data.response_code
        );
      }
    } catch (error) {
      console.error("Error fetching upcoming sessions:", error);
      alert("Failed to fetch upcoming sessions. Please try again later.");
    }
  };

  // Fetch invoices and sessions on component mount
  useEffect(() => {
    fetchPastInvoices();
    fetchUpcomingSessions();
  }, []);

  const generatePdf = async () => {
    const invoiceElement = document.getElementById("invoice");
    if (!invoiceElement) return;

    const downloadBtn = invoiceElement.querySelector(
      '[data-ignore-pdf="true"]'
    );
    if (downloadBtn) downloadBtn.style.display = "none";

    // TEMP: Add padding to fix clipping
    const paddingDiv = document.createElement("div");
    paddingDiv.style.height = "50px"; // buffer space
    invoiceElement.appendChild(paddingDiv);

    const canvas = await html2canvas(invoiceElement, {
      scale: 3,
      scrollY: -window.scrollY,
      useCORS: true,
    });

    invoiceElement.removeChild(paddingDiv); // cleanup

    if (downloadBtn) downloadBtn.style.display = "flex";

    const imgData = canvas.toDataURL("image/png");
    const imgWidth = 595.28;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    const pdf = new jsPDF("p", "pt",  [imgWidth, imgHeight]);
    pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
    pdf.save(`invoice_${selectedInvoice.invoice_code}.pdf`);
  };

  const fetchFullInvoice = async (invoiceId) => {
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) {
      alert("Please log in first.");
      return;
    }

    try {
      const response = await api.get(
        `/display/api/v1/read-invoice/${invoiceId}`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      if (response.data.status === "success") {
        setSelectedInvoice(response.data.data);
        setShowPreview(true);
      } else {
        console.error(
          "Failed to fetch invoice details:",
          response.data.response_code
        );
      }
    } catch (error) {
      console.error("Error fetching full invoice:", error);
    }
  };

  return (
    <div>
      <Header></Header>
      <div className="px-4 sm:px-6 md:px-10 py-5">
        {upcomingSessions.length > 0 && (
          <div
            class="px-4 py-3 flex flex-col gap-4"
            style={{
              border: "1px solid #D9D9D9",
              boxShadow: "0px 1px 4px 0px #00000040",
            }}
          >
            <h1 class="text-2xl font-semibold text-2xl">Invoices</h1>
            <span class="text-lg">
              Here you can select multiple invoices and clear dues in one go.
            </span>
            <div class="flex gap-5">
              <button
                style={{
                  background:
                    "linear-gradient(270deg, #9061DB 0%, #8777F3 100%)",
                }}
                class="px-2 text-white font-bold text-sm rounded"
              >
                Make Payment
              </button>
              <span class="text-lg font-medium">INR 0</span>
            </div>

            <div className="overflow-x-auto">
              <table className="min-w-full table-auto border border-gray-300">
                <thead>
                  <tr className="text-left text-sm font-semibold text-gray-700 border border-gray-300">
                    <th className="w-[12.5%] px-4 py-2 border border-gray-300">
                      <div className="flex items-center gap-2">
                        Invoice number
                      </div>
                    </th>
                    <th className="w-[12.5%] px-4 py-2 border border-gray-300">
                      Invoice date
                    </th>
                    <th className="w-[12.5%] px-4 py-2 border border-gray-300">
                      Amount
                    </th>
                    <th className="w-[12.5%] px-4 py-2 border border-gray-300">
                      Payment status
                    </th>
                    <th className="w-[12.5%] px-4 py-2 border border-gray-300">
                      Action
                    </th>
                  </tr>

                  {upcomingSessions.map((session) => (
                    <tr
                      key={session.id}
                      className="text-left text-sm font-semibold text-gray-700 border border-gray-300"
                    >
                      <th
                        className="w-[12.5%] px-4 py-2 border border-gray-300"
                        style={{ color: "#9061DB" }}
                      >
                        {session.invoice_code}
                      </th>
                      <td className="w-[12.5%] px-4 py-2 border border-gray-300">
                        INR {session.amount}
                      </td>
                      <td className="w-[12.5%] px-4 py-2 border border-gray-300">
                        {session.payment_status === "completed" ? (
                          <span className="text-green-500">Completed</span>
                        ) : (
                          <span className="text-red-500">Pending</span>
                        )}
                      </td>
                      <td className="w-[12.5%] px-4 py-2 border border-gray-300">
                        {new Date(session.invoiced_date).toLocaleDateString()}
                      </td>
                      <td className="w-[12.5%] px-4 py-2 border border-gray-300">
                        Download
                      </td>
                    </tr>
                  ))}
                </thead>
                <tbody>{/* Your rows go here */}</tbody>
              </table>
            </div>
          </div>
        )}

        <div
          class="px-4 py-3 flex flex-col gap-4 mt-5"
          style={{
            border: "1px solid #D9D9D9",
            boxShadow: "0px 1px 4px 0px #00000040",
          }}
        >
          <div class="flex justify-between w-full">
            <h1 class="text-2xl font-semibold text-2xl">Invoices</h1>

            <div class="flex gap-2 items-center">
              {/* <h2 class="text-lg">Downloads</h2> */}
              {/* <img src={DownloadArrow} alt="" class="w-5 h-5" /> */}
            </div>
          </div>

          <div className="overflow-x-auto">
            <table className="min-w-full table-auto border border-gray-300">
              <thead>
                <tr className="text-left text-sm font-semibold text-gray-700 border border-gray-300">
                  <th className="w-[12.5%] px-4 py-2 border border-gray-300">
                     Invoice No
                  </th>
                  <th className="w-[12.5%] px-4 py-2 border border-gray-300">
                    Sub total
                  </th>
                  <th className="w-[12.5%] px-4 py-2 border border-gray-300">
                    Total TAX
                  </th>
                  <th className="w-[12.5%] px-4 py-2 border border-gray-300">
                    Invoice amount
                  </th>
                  <th className="w-[12.5%] px-4 py-2 border border-gray-300">
                    Payment amount
                  </th>
                  <th className="w-[12.5%] px-4 py-2 border border-gray-300">
                    Payment date
                  </th>
                  
                  {/* <th className="w-[1/5] px-4 py-2 border border-gray-300">
                    TDS deduction
                  </th> */}
                  
                  <th className="w-[12.5%] px-4 py-2 border border-gray-300">
                    Status
                  </th>
                  <th className="w-[12.5%] px-4 py-2 border border-gray-300">
                    Action
                  </th>
                </tr>

                {loading ? (
                  <tr>
                    <td colSpan="9" className="text-center">
                      Loading...
                    </td>
                  </tr>
                ) : (
                  pastInvoices.map((invoice) => (
                    <tr
                      className="text-left text-sm font-semibold text-gray-700 border border-gray-300"
                      key={invoice.id}
                    >
                      <th
                        className="w-[12.5%] px-4 py-2 border cursor-pointer  border-gray-300"
                        style={{ color: "#9061DB" }}
                        onClick={() => fetchFullInvoice(invoice.id)}
                      >
                        {invoice.invoice_code}
                      </th>
                      <td className="w-[12.5%] px-4 py-2 border border-gray-300">
                        INR {invoice.sub_total}
                      </td>
                      <td className="w-[12.5%] px-4 py-2 border border-gray-300">
                        INR {invoice.tax_amount}
                      </td>
                      <td className="w-[12.5%] px-4 py-2 border border-gray-300">
                        INR {invoice.invoice_amount}
                      </td>
                      <td className="w-[12.5%] px-4 py-2 border border-gray-300">
                        INR {invoice.payment_amount}
                      </td>
                      <td className="w-[12.5%] px-4 py-2 border border-gray-300">
                        {invoice.payment_date
                          ? new Date(invoice.payment_date).toLocaleDateString(
                              "en-GB"
                            )
                          : "Not Paid"}
                      </td>
                      
                      {/* <td className="w-[1/5] px-4 py-2 border border-gray-300">
                        INR {invoice.tds_amount}
                      </td> */}
                      
                      <td className="w-[12.5%] px-4 py-2 border border-gray-300">
                        {invoice.payment_date ? (
                          <span className="text-green-500">Paid</span>
                        ) : (
                          <span className="text-red-500">Due</span>
                        )}
                      </td>
                      <td
                        className="w-[12.5%] px-4 py-2 border border-gray-300 cursor-pointer"
                        onClick={() => fetchFullInvoice(invoice.id)}
                      >
                        <div className="flex items-center gap-2">
                          <span className="whitespace-nowrap">Download</span>
                          <img
                            src={DownloadArrow}
                            alt="Download Arrow"
                            className="w-4 h-4"
                          />
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </thead>
              <tbody>{/* Your rows go here */}</tbody>
            </table>
          </div>
        </div>
      </div>
      {showPreview && selectedInvoice && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
          <div className="bg-white w-full h-[90vh] overflow-y-auto rounded shadow-lg relative p-4" style={{ maxWidth: "1200px" }}>

            <div className="flex w-[1100px] justify-between">
              <h2 className="text-xl font-bold mb-4">Invoice Preview</h2>
              <button
                onClick={() => setShowPreview(false)}
                className="
    inline-flex items-center h-7
    bg-gray-100 hover:bg-gray-200
    text-gray-700 hover:text-gray-900
    px-1.5 py-1 rounded-md
    border border-gray-300
    shadow-sm
    transition
    duration-150
    ease-in-out
    focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-1
    cursor-pointer
  "
              >
                {/* SVG Close icon */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-3 w-3"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>

            <div
              id="invoice"
              style={{
                width: "1100px",
                padding: "20px 20px",
                margin: "0 auto",
                boxSizing: "border-box",
              }}
            >
              <InvoiceTemplate
                invoice={selectedInvoice}
                generatePdf={generatePdf}
              />
            </div>

            {/* <div className="mt-4 flex justify-end gap-4">
              <button
                onClick={() => setShowPreview(false)}
                className="px-4 py-2 text-sm font-semibold bg-gray-300 text-black rounded"
              >
                Close
              </button>
              <button
                onClick={generatePdf}
                className="px-4 py-2 text-sm font-semibold bg-purple-600 text-white rounded"
              >
                Download PDF
              </button>
            </div> */}
          </div>
        </div>
      )}
    </div>
  );
};

export default ViewInvoice;
